import { useState } from 'react';
import { IcoClose } from './common/Icons.jsx';
import styles from './CancelOrderSheet.module.css';

// Los motivos son una lista cerrada porque el objetivo es poder AGRUPARLOS: con
// texto libre el reporte diría "se canceló mucho" pero nunca por qué. La nota
// queda para el detalle que no cabe en una categoría.
const MOTIVOS = [
  { key: 'error_captura',  label: 'Error de captura',   hint: 'Se mandó lo que no era' },
  { key: 'cliente_cambio', label: 'El cliente cambió',  hint: 'Pidió otra cosa' },
  { key: 'demora',         label: 'Demora',             hint: 'Tardó y ya no lo quiso' },
  { key: 'sin_insumo',     label: 'Sin insumo',         hint: 'Se acabó algo' },
  { key: 'calidad',        label: 'Calidad',            hint: 'Salió mal, se rehace' },
  { key: 'otro',           label: 'Otro',               hint: '' },
];

export default function CancelOrderSheet({ open, order, onCancel, onClose }) {
  const [motivo,   setMotivo]   = useState(null);
  const [nota,     setNota]     = useState('');
  const [tirado,   setTirado]   = useState(null);   // null = sin decidir
  const [enviando, setEnviando] = useState(false);
  const [error,    setError]    = useState(null);

  if (!open || !order) return null;

  const confirmar = async () => {
    setEnviando(true); setError(null);
    try {
      await onCancel({ reason: motivo, note: nota || null, wasted: tirado === true });
      setMotivo(null); setNota(''); setTirado(null);
      onClose();
    } catch (err) {
      setError(err.response?.data?.error ?? 'No se pudo cancelar');
    } finally { setEnviando(false); }
  };

  return (
    <div className={styles.scrim} role="presentation" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className={styles.sheet} role="dialog" aria-modal="true">
        <div className={styles.head}>
          <div>
            <h2 className={styles.title}>Cancelar comanda #{order.folio}</h2>
            <p className={styles.sub}>{order.tab_name ?? 'Sin mesa'} · {order.items?.length ?? 0} platillo(s)</p>
          </div>
          <button className={styles.close} onClick={onClose} aria-label="Cerrar"><IcoClose size={16} /></button>
        </div>

        <p className={styles.label}>¿Por qué?</p>
        <div className={styles.motivos}>
          {MOTIVOS.map((m) => (
            <button
              key={m.key}
              className={`${styles.motivo} ${motivo === m.key ? styles.motivoOn : ''}`}
              onClick={() => setMotivo(m.key)}
            >
              <strong>{m.label}</strong>
              {m.hint && <small>{m.hint}</small>}
            </button>
          ))}
        </div>

        {/* Esta pregunta decide si el inventario se corrige o no: es el dato
            más importante del formulario, no un detalle. */}
        <p className={styles.label}>¿Ya estaba preparado?</p>
        <div className={styles.tirado}>
          <button
            className={`${styles.opcion} ${tirado === false ? styles.opcionOn : ''}`}
            onClick={() => setTirado(false)}
          >
            <strong>No</strong>
            <small>Los insumos vuelven al almacén</small>
          </button>
          <button
            className={`${styles.opcion} ${tirado === true ? styles.opcionOn : ''}`}
            onClick={() => setTirado(true)}
          >
            <strong>Sí, se tira</strong>
            <small>Se registra como merma</small>
          </button>
        </div>

        <input
          className={styles.nota}
          placeholder="Nota (opcional)"
          value={nota}
          onChange={(e) => setNota(e.target.value)}
        />

        {error && <p className={styles.error}>{error}</p>}

        <div className={styles.acciones}>
          <button className="btn btn--ghost" onClick={onClose} disabled={enviando}>Volver</button>
          <button
            className="btn btn--danger"
            onClick={confirmar}
            disabled={enviando || !motivo || tirado === null}
          >
            {enviando ? 'Cancelando…' : 'Cancelar comanda'}
          </button>
        </div>
      </div>
    </div>
  );
}
